var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGrafico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_8198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2945 -1.52588e-05H6.70568C4.10988 -1.52588e-05 2.00574 2.10426 2.00574 4.69993V59.2999C2.00574 61.8957 4.11001 63.9998 6.70568 63.9998H57.2945C59.8902 63.9998 61.9945 61.8955 61.9945 59.2999V4.69993C61.9946 2.10426 59.8903 -1.52588e-05 57.2945 -1.52588e-05V-1.52588e-05Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86892 59.3V4.70005C5.86892 2.10426 7.97306 -1.52588e-05 10.5689 -1.52588e-05H6.70568C4.10988 -1.52588e-05 2.00574 2.10426 2.00574 4.70005V59.3C2.00574 61.8957 4.11001 63.9999 6.70568 63.9999H10.5689C7.97306 63.9999 5.86892 61.8957 5.86892 59.3Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7369 14.2957H12.3914C11.3525 14.2957 10.5102 15.138 10.5102 16.1769V26.3197C10.5102 27.3586 11.3525 28.2009 12.3914 28.2009H16.7369C17.7758 28.2009 18.6181 27.3586 18.6181 26.3197V16.1769C18.6181 15.138 17.7758 14.2957 16.7369 14.2957Z",
    fill: "#FF7F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3734 26.3197V16.1769C14.3734 15.138 15.2157 14.2957 16.2546 14.2957H12.3914C11.3525 14.2957 10.5102 15.138 10.5102 16.1769V26.3197C10.5102 27.3586 11.3525 28.2009 12.3914 28.2009H16.2546C15.2157 28.2009 14.3734 27.3588 14.3734 26.3197Z",
    fill: "#FF5D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3806 9.96019H24.0351C22.9962 9.96019 22.1539 10.8025 22.1539 11.8414V26.3197C22.1539 27.3587 22.9962 28.201 24.0351 28.201H28.3806C29.4195 28.201 30.2618 27.3587 30.2618 26.3197V11.8414C30.2618 10.8025 29.4195 9.96019 28.3806 9.96019Z",
    fill: "#FFABCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0171 26.3197V11.8416C26.0171 10.8026 26.8594 9.96034 27.8983 9.96034H24.0351C22.9962 9.96034 22.1539 10.8026 22.1539 11.8416V26.3197C22.1539 27.3587 22.9962 28.201 24.0351 28.201H27.8983C26.8594 28.201 26.0171 27.3588 26.0171 26.3197Z",
    fill: "#FF5D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6882 7.41H36.3428C35.3038 7.41 34.4615 8.25231 34.4615 9.29124V26.3197C34.4615 27.3587 35.3038 28.201 36.3428 28.201H40.6882C41.7271 28.201 42.5694 27.3587 42.5694 26.3197V9.29124C42.5694 8.25218 41.7271 7.41 40.6882 7.41Z",
    fill: "#BD9CDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3247 26.3197V9.29124C38.3247 8.25231 39.167 7.41 40.206 7.41H36.3428C35.3038 7.41 34.4615 8.25231 34.4615 9.29124V26.3197C34.4615 27.3587 35.3038 28.201 36.3428 28.201H40.206C39.1669 28.201 38.3247 27.3588 38.3247 26.3197Z",
    fill: "#8C5AC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9959 13.0206H48.6505C47.6115 13.0206 46.7692 13.8629 46.7692 14.9018V26.3197C46.7692 27.3586 47.6115 28.2009 48.6505 28.2009H52.9959C54.0348 28.2009 54.8771 27.3586 54.8771 26.3197V14.9018C54.8771 13.8629 54.0348 13.0206 52.9959 13.0206Z",
    fill: "#00D7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6324 26.3197V14.9018C50.6324 13.8629 51.4747 13.0206 52.5137 13.0206H48.6505C47.6115 13.0206 46.7692 13.8629 46.7692 14.9018V26.3197C46.7692 27.3586 47.6115 28.2009 48.6505 28.2009H52.5137C51.4746 28.2009 50.6324 27.3588 50.6324 26.3197Z",
    fill: "#00AE8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8041 35.1803L46.1728 40.4774L44.8041 45.7744L42.5831 50.4247L37.3147 53.2639L37.3134 53.2652C35.396 51.349 34.21 48.7002 34.21 45.7744C34.21 39.9243 38.9527 35.1803 44.8041 35.1803Z",
    fill: "#BD9CDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2935 53.2663V53.2638L47.2903 51.0714L44.8041 45.7744L50.4319 43.8757L55.3982 45.7744C55.3982 48.7014 54.2122 51.3502 52.2935 53.2663Z",
    fill: "#FF7F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3982 45.7744H44.8041V35.1803C50.6555 35.1803 55.3982 39.9243 55.3982 45.7744Z",
    fill: "#00D7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2936 53.2637V53.2663C50.3774 55.1825 47.7286 56.3684 44.8041 56.3684C41.8784 56.3684 39.2296 55.1825 37.3134 53.265L37.3147 53.2637L44.8041 45.7743L52.2936 53.2637Z",
    fill: "#FFABCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6656 41.8461H13.1805C12.6984 41.8461 12.3077 41.2951 12.3077 40.6154C12.3077 39.9357 12.6984 39.3846 13.1805 39.3846H28.6656C29.1478 39.3846 29.5384 39.9357 29.5384 40.6154C29.5384 41.2951 29.1478 41.8461 28.6656 41.8461Z",
    fill: "#42394B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6656 46.7692H13.1805C12.6984 46.7692 12.3077 46.2182 12.3077 45.5385C12.3077 44.8587 12.6984 44.3077 13.1805 44.3077H28.6656C29.1478 44.3077 29.5384 44.8587 29.5384 45.5385C29.5384 46.2182 29.1478 46.7692 28.6656 46.7692Z",
    fill: "#42394B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6656 51.6923H13.1805C12.6984 51.6923 12.3077 51.1413 12.3077 50.4615C12.3077 49.7818 12.6984 49.2308 13.1805 49.2308H28.6656C29.1478 49.2308 29.5384 49.7818 29.5384 50.4615C29.5384 51.1413 29.1478 51.6923 28.6656 51.6923Z",
    fill: "#42394B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_8198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrafico);
export default __webpack_public_path__ + "static/media/icon_grafico.294bd34e855fc7d7537f14a05d315a06.svg";
export { ForwardRef as ReactComponent };